import {
  type ParkingSpot,
  type ParkingSpotRevenueRow,
} from '@pigello/pigello-matrix';
import { createBaseRentHandler } from './shared-base-rent-handler';
import { withBuildingRealEstate } from './shared-building-realestate';

const baseHandler = createBaseRentHandler<ParkingSpot, ParkingSpotRevenueRow>(
  'parkingspotrevenuerow'
);

export async function handleCustomParkingSpotNestedCase(
  listResponse: Parameters<typeof baseHandler>[0]
) {
  const withRevenue = await baseHandler(listResponse);
  return withBuildingRealEstate(withRevenue);
}
